import { ReactElement } from 'react';
import styled from 'styled-components';

import { PageContainerProps } from './page-container.types'
import { getPageContainerStyles } from './page-container.styles'

const StyledPageContainer = styled.div`
  ${getPageContainerStyles}
`


/** PAGE CONTAINER */
export const PageContainer = ({ children, className = '' }: PageContainerProps): ReactElement => {
  return (
    <StyledPageContainer className={className}>
      {children}
    </StyledPageContainer>
  )
}